<template>
	<section class="pre-footer-section align-center">
		<div class="row">
			<div class="columns column7">
				<picture>
					<source :srcset="footerSection.imageWebp" type="image/webp" />
					<source :srcset="footerSection.image" />
					<img :src="footerSection.image" :alt="footerSection.imageAlt" loading="lazy" />
				</picture>
			</div>
			<div class="columns column5">
				<h2>{{ footerSection.header }}</h2>
				<div v-parse-links v-html="footerSection.content" />
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	footerSection: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.pre-footer-section {
	.row {
		display: flex;
		flex-flow: row wrap;
		place-content: center center;
	}

	.column5 {
		padding: 0 60px;
		display: flex;
		flex-flow: column wrap;
		justify-content: center;
		align-items: center;
	}

	h2 {
		max-width: 540px;
		margin: 0 auto 20px;
		color: var(--header-color-secondary);
	}

	img {
		width: 100%;
		height: 100%;
	}
}

@media (max-width: 1080px) {
	.pre-footer-section {
		.column5 {
			width: 100%;
			margin: 50px auto 0;
			padding: 0 20px;
		}
	}
}
</style>
